const data = {
  searchDTO: {
    keyword: '',
    currentPage: 1,
    pageSize: 10,
    sortingMethod: '',
    reverseOrder: 0,
    type: 'all',
    freeBook: 0,
    tryRead: 0,
    customBook: 0,
    userId: '',
    // 返回的结果类型，"all", "sidebar", "bookList"
    returnType: 'all',
    // libraryStrict: '',
    sideBarInfo: {
      sideBarClassify: [],
      sideBarLibrarySite: [],
      sideBarDynasty: [],
      sideBarEdition: [],
      sideBarYear: [],
      sideBarAuthor: []
    }
  },
  originSearchDTO: {
    keyword: '',
    currentPage: 1,
    pageSize: 10,
    sortingMethod: '',
    reverseOrder: 0,
    type: 'all',
    freeBook: 0,
    tryRead: 0,
    customBook: 0,
    userId: null,
    exactSearch: 1,
    returnType: 'all',
    // libraryStrict: '',
    sideBarInfo: {
      sideBarClassify: [],
      sideBarLibrarySite: [],
      sideBarDynasty: [],
      sideBarEdition: [],
      sideBarYear: [],
      sideBarAuthor: []
    }
  },
  advancedSearchDTO: {
    bookName: '',
    classification: '',
    author: '',
    edition: '',
    completionDynasty: '',
    librarySite: '',
    // libraryStrict: '', // 地域搜索限定
    description: '',
    text: '',
    currentPage: 1,
    pageSize: 10,
    sortingMethod: '',
    reverseOrder: 0,
    exactSearch: 1,
    userId: localStorage.getItem('userId'),
    returnType: 'all',
    sideBarInfo: {
      sideBarClassify: [],
      sideBarLibrarySite: [],
      sideBarDynasty: [],
      sideBarYear: [],
      sideBarEdition: [],
      sideBarAuthor: []
    }
  },
  wordList: {},
  brief: ''
}

export default data



// WEBPACK FOOTER //
// ./src/store/global.js